module.exports = __webpack_public_path__ + "img/表1-4图线及其应用.dbf9a148.png";